import "stylesheets/ticket_smart_phone"
